// extracted by mini-css-extract-plugin
export var header = "_tv-1";
export var maskBottom = "_tv-6";
export var maskMiddle = "_tv-7";
export var maskTop = "_tv-5";
export var root = "_tv-0";
export var scrollDownButton = "_tv-3";
export var scrollDownButtonHidden = "_tv-4";
export var viewport = "_tv-2";